import { Youtube, Twitch, Instagram, Facebook, Twitter, Music2, Zap } from "lucide-react";
import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { SocialCard } from "@/components/socials/SocialCard";
import { SOCIAL_LINKS } from "@/config/site";
import { MEDIA } from "@/config/media";

const ICONS = { youtube: Youtube, twitch: Twitch, kick: Zap, tiktok: Music2, instagram: Instagram, x: Twitter, facebook: Facebook };

export default function Socials() {
  return (
    <div data-testid="socials-page">
      <SEO
        title="Follow WomensMatchDayLive"
        description="Follow WomensMatchDayLive across YouTube, Twitch, Kick, TikTok, Instagram, X and Facebook for grassroots women's football coverage."
        path="/socials"
      />
      <PageHero
        eyebrow="Socials"
        title="Socials"
        subtitle="Follow along across every platform for grassroots women's football coverage."
        crumbLabel="Socials"
        backgroundImage={MEDIA.socialsHero.url}
        backgroundAlt={MEDIA.socialsHero.alt}
      />

      <section className="bg-surface-dark py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-12">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SOCIAL_LINKS.map((link, i) => (
              <Reveal key={link.id} delay={i * 0.05}>
                <SocialCard link={link} Icon={ICONS[link.id]} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
